// Services/fetchSetPaymentStatus.js
import { REPORTS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

// tipo: "negocio" | "repartidor" | "repartidorDebtAdmin"
// pagadoAt: ISO datetime string (requerido si pagado=true)
// date (opcional, "YYYY-MM-DD"): semana que contiene esa fecha; si no se pasa, semana actual
export const fetchSetPaymentStatus = async ({ tipo, entidadId, pagado, pagadoAt, date }) => {
  const res = await ApiRequestInterceptor(REPORTS.setPaymentStatus, "POST", {
    tipo,
    entidadId,
    pagado,
    pagadoAt,
    date,
  });

  if (res?.code === 200) {
    return { statusCode: 200, ...res.data };
  }
  if (res?.code === 401) return { statusCode: 401, message: res?.data?.message || "Token inválido o expirado" };
  if (res?.code === 403) return { statusCode: 403, message: res?.data?.message || "No autorizado" };

  return {
    statusCode: res?.code || 500,
    message: res?.data?.message || "Error al actualizar el estado de pago",
  };
};
